
import {
    gql
  } from "@apollo/client";
import { privateClient as client } from '..';
import { commonErrorHandling } from '../Utils/index';

export default function* isWdAuthIntegrated() {
   

    const servicesList = gql`
        {
            isWdAuthIntegrated{
                status,
                connected_at,
                consumer_key,
                consumer_secret
            }
        }
    `;
    const response = yield client
      .query({
        query: servicesList,
        fetchPolicy: 'no-cache',
      })
      .then(result => {
        return {
            success:true,
            payload:result
        };
      }
    ).
    catch(e => {
        commonErrorHandling( e)
        return {
            success:false,
            payload:e
        };
    })
    
    return response;
      
}
